import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { ChatOutlinedIcon } from '../SvgIcons';

interface AgentChatActionProps {
  displayIconText?: boolean;
}

const AgentChatAction: React.FC<AgentChatActionProps> = ({
  displayIconText,
}) => {
  const history = useHistory();
  const { spacing, textIcon, styleIcon } = useStyles();

  return (
    <ButtonBase
      onClick={() => {
        history.push('/agent/chat');
      }}
      className={spacing}
    >
      <Box className={styleIcon}>{ChatOutlinedIcon}</Box>
      <Box className={textIcon}>
        {displayIconText && <FormattedMessage id="HeaderMenu.Chats" />}
      </Box>
    </ButtonBase>
  );
};

export default AgentChatAction;

const useStyles = makeStyles(theme => ({
  spacing: { display: 'flex', gap: '8px', alignItems: 'center' },
  textIcon: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 500,
  },
  styleIcon: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.text.secondary
        : 'rgb(63, 63, 70)',
    display: 'flex',
    justifyContent: 'center',
    width: 24,
  },
}));
